import { FormattedMessage } from 'react-intl';
import { useGetSubscription } from 'store/subscription/actions';

export const SubscriptionStatusBanner = () => {
  const { data: subscription, isError } = useGetSubscription();

  if (isError) return null;

  const activeSubscription = subscription?.subscriptions.find(
    (sub) => sub.product_type.toLowerCase() === 'menu',
  );

  const daysLeft = (() => {
    const nextPayment = activeSubscription?.next_payment_date;
    if (!nextPayment) return null;
    const now = Date.now();
    const nextDate = new Date(nextPayment).getTime();
    if (isNaN(nextDate)) return null;
    const diff = Math.ceil((nextDate - now) / (1000 * 60 * 60 * 24));
    return diff > 0 ? diff : 0;
  })();

  const getBannerText = () => {
    if (activeSubscription?.status === 'Cancel') {
      return <FormattedMessage id="subscriptionBannerCancelText" />;
    } else if (activeSubscription?.status === 'InActive') {
      return <FormattedMessage id="subscriptionBannerExploreText" />;
    } else {
      return (
        <FormattedMessage
          id="subscriptionBannerPastDueText"
          values={{
            N: daysLeft,
          }}
        />
      );
    }
  };

  return (
    <div className="relative flex items-center justify-center gap-x-6 py-2 px-6 min-h-fit bg-[radial-gradient(80%_100%_at_0%_50%,#ede9fe_0%,#f5f3ff_40%,#9089fc33_100%)] flex-shrink-0 sm:px-3.5">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <p className="text-sm text-gray-900">{getBannerText()}</p>
        <a
          href="/subscription"
          className="flex-none rounded-full bg-gray-900 px-3.5 py-1 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
        >
          <FormattedMessage id="subscriptionBannerButton" />{' '}
          <span aria-hidden="true">&rarr;</span>
        </a>
      </div>
    </div>
  );
};
